import {
  SidePanelLayout,
  SidePanelPersonalizationState,
  SidePanelProfile,
} from './layout.types';

export interface ResolveEffectiveLayoutInput {
  canPersonalize: boolean;
  state: SidePanelPersonalizationState | null;
  userProfiles: SidePanelProfile[];
  groupProfiles: SidePanelProfile[];
  builtinDefault: SidePanelProfile;
}

export interface ResolvedPersonalization {
  layout: SidePanelLayout;
  activeProfile: SidePanelProfile | null;
  isDraft: boolean;
}

export function resolveEffectiveLayout(
  input: ResolveEffectiveLayoutInput,
): ResolvedPersonalization {
  const { canPersonalize, state, userProfiles, groupProfiles, builtinDefault } = input;

  const groupPick = [...groupProfiles].sort((a, b) => a.name.localeCompare(b.name))[0] ?? null;

  if (!canPersonalize) {
    const profile = groupPick ?? builtinDefault;

    return { layout: profile.layout, activeProfile: profile, isDraft: false };
  }

  const profilesById = new Map<string, SidePanelProfile>(
    [builtinDefault, ...groupProfiles, ...userProfiles].map((p) => [p.id, p]),
  );

  const activeProfile = state?.activeProfileId
    ? (profilesById.get(state.activeProfileId) ?? null)
    : null;

  if (state?.draft) {
    return { layout: state.draft, activeProfile, isDraft: true };
  }

  const profile = activeProfile ?? groupPick ?? builtinDefault;

  return { layout: profile.layout, activeProfile: profile, isDraft: false };
}
